/**
 * Created by Rodrigo Quesada on 25/05/17.
 */
import {NgModule} from '@angular/core';
import {AutoLogoutService} from './auto-logout.service';

@NgModule({
    providers: [AutoLogoutService]
})
export class AutoLogoutModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/autologout/auto-logout.module.ts